<template>
  <div class="mobile-empty-container" v-if="loading">
    <van-empty image="https://img01.yzcdn.cn/vant/custom-empty-image.png" description="页面跳转中..." />
  </div>
  <div class="mobile-container" v-else-if="hasViewRight">
    <keep-alive>
      <router-view />
    </keep-alive>
    <van-tabbar v-model="active" active-color="#f1303d" inactive-color="#000" @change="onChangeTab">
      <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item name="kpi" icon="bar-chart-o" v-if="canViewKpi">指标</van-tabbar-item>
      <van-tabbar-item name="tasks" icon="todo-list-o" v-if="canViewTasks">任务</van-tabbar-item>
      <van-tabbar-item name="my" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
  <div class="mobile-empty-container" v-else>
    <van-empty image="search" description="您无权限浏览，请联系管理员。" />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { hasOneOf } from '@/util'
import { fetchUserInfo, fetchRoleCodeList } from '@/services/UserService'

export default {
  name: 'MobileIndex',
  data() {
    return {
      openId: localStorage.getItem('openId'),
      active: this.$route.name.split('-')[1],
      loading: true,
      roleCodeList: [],
      canViewKpi: false,
      canViewTasks: false,
      hasViewRight: false
    }
  },
  async mounted() {
    this.loading = true
    await this.onInitUserInfo()
    await this.onInitRoleCodeList()
    setTimeout(() => {
      this.loading = false
    }, 300)
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    async onInitUserInfo() {
      const response = await fetchUserInfo({
        openId: this.openId
      })
      this.setUserInfo(response.data)
    },
    async onInitRoleCodeList() {
      const response = await fetchRoleCodeList({ openId: this.openId })
      const roleCodeList = response.data || []
      this.roleCodeList = roleCodeList
      this.canViewKpi = roleCodeList && roleCodeList.length &&
        hasOneOf(roleCodeList, ['T', 'M', 'VL', 'V', 'L1', 'CALL_LINE_MANAGER'])
      this.canViewTasks = roleCodeList && roleCodeList.length &&
        hasOneOf(roleCodeList, ['L1'])
      this.hasViewRight = roleCodeList && roleCodeList.length &&
        hasOneOf(roleCodeList, ['T', 'M', 'VL', 'V', 'L1', 'C', 'CALL_LINE_MANAGER'])
    },
    onChangeTab(name) {
      this.$router.replace(`/m/${name}`)
    }
  }
}
</script>
<style lang="less">
.mobile-empty-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
